import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.jsx'
import LoginPage from './pages/LoginPage.jsx'
import { useAuth } from './hooks/useAuth.js'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 20_000, retry: 1, refetchOnWindowFocus: false } },
})

// Dev runs auth-free (server/index.js skips auth there); a prod build gates on a
// real auth.yokan.io session, like yokan-ginko.
function Root() {
  const { authenticated, loading } = useAuth()
  if (import.meta.env.DEV) return <App />
  if (loading) return null
  if (!authenticated) return <LoginPage />
  return <App />
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Root />
    </QueryClientProvider>
  </StrictMode>,
)
